<script setup lang="ts">
import { ref } from 'vue'
import { usePageLoaded } from '../composables/usePageLoaded'
import { useSectionReveal } from '../composables/useSectionReveal'
import type { LocalizedCopy } from '../types/site'
import SectionTitle from './SectionTitle.vue'

defineProps<{
  copy: LocalizedCopy
  media: string
  watermarkImage: string
}>()

const sectionRoot = ref<HTMLElement | null>(null)
useSectionReveal(sectionRoot)
const pageLoaded = usePageLoaded()
</script>

<template>
  <section ref="sectionRoot" class="transport-section page-section" data-track-section="transport">
    <SectionTitle
      eyebrow="DELIVERY"
      :title="copy.transport.title"
      :watermark="watermarkImage"
    />
    <div class="transport-section__copy">
      <p v-for="paragraph in copy.transport.paragraphs" :key="paragraph">{{ paragraph }}</p>
    </div>
    <img class="transport-section__media" :src="pageLoaded ? media : undefined" alt="Order fulfillment" loading="lazy" decoding="async" />
  </section>
</template>
